import { Routes } from '@angular/router';
import { GOOGLE_ANALYTICS_SECTION_ROUTE_SEGMENTS } from './molecules/ga-section-registry/ga-section.registry';
import { AccountMode } from './molecules/account-mode/account-mode';
import { AccountModeDashboard } from './molecules/account-mode/account-mode-dashboard/account-mode-dashboard';
import { AccountModeList } from './molecules/account-mode/account-mode-list/account-mode-list';

export const adminGoogleAnalyticsRoutes: Routes = [
  { path: '', redirectTo: GOOGLE_ANALYTICS_SECTION_ROUTE_SEGMENTS['account-mode'], pathMatch: 'full' },
  {
    path: GOOGLE_ANALYTICS_SECTION_ROUTE_SEGMENTS['account-mode'],
    component: AccountMode,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: AccountModeDashboard },
      { path: 'list', component: AccountModeList },
    ],
  },
];
